module.exports = __webpack_public_path__ + "img/chat.0b14bf07.svg";